import React, { useState, useEffect, useRef } from 'react';

import './commons.scss';

const TSPage = function ({ id, name, className, pageState, children, onClick }) {
    let classes = ["page"];
    if (className)
        classes.push(className);
    switch (pageState) {
        case "add":
            classes.push("mounting");
            break;
        case "active":
            classes.push("mounted");
            break;
        case "remove":
            classes.push("unmounting");
            break;
        default:
    }
    if (name)
        classes.push(name + "Page");

    return (
        <div id={id} className={classes.join(" ")} onClick={onClick}>
            {children}
        </div>);
};


const TSInput = function ({ id, doOnSubmit, type, initialValue, value, onChange, style, className, placeholder, inputMode, autoComplete }) {
    const [state, setState] = useState({ value: initialValue || value || "" });

    useEffect(() => {
        //if (value !== undefined && value !== state.value)
        setState({ value: value })
        // eslint-disable-next-line
    }, [value]);

    useEffect(() => {
        if (onChange)
            onChange(
                { target: { value: state.value } }
            );
    }, []);

    var newProps = { id, value: state.value || "", style, type, className, placeholder, inputMode, autoComplete };
    newProps.onChange = (e) => {
        if (onChange) {
            if (onChange(e))
                setState({ value: e.target.value });
        }
        else
            setState({ value: e.target.value });
    };

    if (doOnSubmit) {
        return <form onSubmit={doOnSubmit}>{React.createElement("input", newProps)}</form>
    } else {
        return React.createElement("input", newProps);
    }
}

const TSToggle = function ({ style, value, onChange, alwaysOn }) {
    const [stateValue, setStateValue] = useState(!!value);

    const handleClick = (e) => {
        setStateValue(!stateValue);
        if (onChange)
            onChange(!stateValue);
    };

    return (
        <div className={"ts-toggle" + (stateValue ? " on" : "")} style={{ fontSize: style?.height || "1.2em" }} onClick={handleClick}>
            <div className="track">
                <div className="marker"></div>
            </div>
        </div>
    );
}

const TSLineSelector = function (props) {
    const [stateIdx, setStateIdx] = useState(0);

    const handleClick = (idx, value) => {
        setStateIdx(idx);
        if (props.onChange)
            props.onChange(idx, value);
    };

    let options = [];
    (props.options || []).forEach((v, k) => {
        options.push(
            <div key={"o" + k} className={"part" + (stateIdx === k ? " selected" : "")} data-content={v.d || v.v || ""} style={{ width: (100 / (props.options.length || 1)) + "%" }} onClick={handleClick.bind(this, k, v.v)}>
                <div className="marker" />
            </div>
        );
    });

    let mpos = props.options.length <= 1 ? "50%" : (100 / (props.options.length - 1)) * stateIdx + "%"

    return (
        <div className="ts-line-selector" style={{ fontSize: props.style?.height || "1.2em" }} >
            <div className="bg">
                {options}
            </div>
            <div className="slider">
                <div className="marker on" style={{ right: mpos }} />
            </div>
        </div>
    );
}

const TSAccordion = React.forwardRef(function ({ titleComponent, title, children, forceToggle, onToggle, uiParams }, ref) {
    const content = useRef(null);

    const [stateOpen, setStateOpen] = useState(!!forceToggle);
    const [stateHeight, setStateHeight] = useState(!!forceToggle ? `${content.current?.scrollHeight}px` : "0px");

    useEffect(() => {
        if (forceToggle !== undefined) {
            setStateOpen(!!forceToggle);
            setStateHeight(
                !forceToggle ? "0px" : `${content.current.scrollHeight}px`
            );
        }
    }, [forceToggle]);

    useEffect(() => {
        resetHeight()
    }, [uiParams?.windowSize, children]);

    const handleToggle = function (onoff) {
        setStateOpen(onoff === undefined ? !stateOpen : onoff);
        setStateHeight(stateOpen ? "0px" : `${content.current?.scrollHeight || 0}px`);

        if (onToggle) {
            setTimeout(() => {
                onToggle(!stateOpen, content.current);
            }, 330);
        }
    };

    const handleChildChanged = function () {
        resetHeight();
    }

    const resetHeight = function () {
        setStateHeight(!stateOpen ? "0px" : `${content.current?.scrollHeight || 0}px`);
    }

    let tc = titleComponent || "h1";
    let newChildren = children;
    if (children && Array.isArray(children)) {
        newChildren = [...children].map(v => {
            if (v?.type === TSAccordion)
                return { ...v, props: { ...v.props, onToggle: handleChildChanged } };
            else
                return v;
        });
    }

    return (
        <div ref={ref} className={"ts-accordion" + (stateOpen ? " open" : "")}>
            {
                React.createElement(tc, { className: "header", onClick: handleToggle.bind(this, undefined) },
                    [
                        <span key="title">{title}</span>,
                        <button key="button"><img src="img/chevron-down.svg" alt="open/close" /></button>
                    ]
                )
            }
            <div className="content" style={{ maxHeight: `${stateHeight}` }} ref={content}>
                {newChildren}
            </div>
        </div>
    );
});

const TSOptionsSelector = function ({ highlight, options, selectOptions, onSelected }) {
    let firstChoice = [];
    let secondChoice = [];
    (options || []).forEach((v, k) => {
        let text = (v.text ?? v) || "";
        if (!text || !text.indexOf)
            return true;

        let pos = text.indexOf(highlight);
        if (v.first)
            firstChoice.push(
                <div key={"s" + k} onClick={onSelected?.bind(this, v)}>{text}</div>
            );
        else if (pos === 0)
            firstChoice.push(
                <div key={"s" + k} onClick={onSelected?.bind(this, v)}><span>{text.substring(0, pos)}</span><b>{highlight}</b><span>{text.substring(pos + highlight.length)}</span></div>
            );
        else if (pos > 0)
            secondChoice.push(
                <div key={"s" + k} onClick={onSelected?.bind(this, v)}><span>{text.substring(0, pos)}</span><b>{highlight}</b><span>{text.substring(pos + highlight.length)}</span></div>
            );
    });

    /*if (selectOptions?.addBefore) {
        firstChoice = selectOptions.addBefore.map((v, k) => {
            return <div key={"c" + k} onClick={onSelected?.bind(this, v)}>{v.text ?? v}</div>
        }).concat(firstChoice);
    }*/

    return (
        <div className="ts-options-selector">
            {firstChoice}
            {secondChoice}
        </div>
    );
}

const TSDateInput = ({ id, doOnSubmit, onChange, className }) => {
    const [stateDate, setStateData] = useState({ pre: "", post: "dd/mm/yyyy" });
    const [stateInp, setStateInp] = useState("");

    const handleInputChanged = (e) => {
        let value = e.target.value || "";
        let clean = value.split("").filter(v => v >= '0' && v <= '9').join("");

        let res = "";
        let step = { stage: "d", val: -1 };
        clean.split("").forEach((v) => {
            switch (step.stage) {
                case "d":
                    if (step.val < 0) {
                        step.val = v * 1;
                        res += v;
                    } else {
                        if (step.val * 10 + v * 1 <= 31 && step.val * 10 + v * 1 >= 1) {
                            step.val = step.val * 10 + v * 1;
                            res += v;
                            step = { stage: "m", val: -1 }
                        }
                        else
                            return false;
                    }
                    break;
                case "m":
                    if (step.val < 0) {
                        step.val = v * 1;
                        res += v;
                    } else {
                        if (step.val * 10 + v * 1 <= 12 && step.val * 10 + v * 1 >= 1) {
                            step.val = step.val * 10 + v * 1;
                            res += v;
                            step = { stage: "y", val: -1 }
                        }
                        else
                            return false;
                    }
                    break;
                case "y":
                    if (step.val < 0) {
                        if (v * 1 < 3 && v * 1 > 0) {
                            step.val = v * 1;
                            res += v;
                        } else
                            return false;
                    } else {
                        res += v;
                        if (res.length >= 8)
                            step = { stage: "f", val: -1 }
                    }
                    break;
                default:
                    return false;
            }
        });

        if (value && (value.charAt(value.length - 1) === '.' || value.charAt(value.length - 1) === '/')) {
            if (step.stage === 'd' && res.length === 1 && res * 1 > 0)
                res = '0' + res;
            else if (step.stage === 'm' && res.length === 3 && res.substring(2, 3) * 1 > 0)
                res = res.substring(0, 2) + '0' + res.substring(2, 3);
        }

        let pre = "";
        let post = "";
        if (res.length < 2) {
            pre = res;
            post = (res.length < 1 ? "d" : "") + "d/mm/yyyy";
        } else if (res.length < 4) {
            pre = res.substring(0, 2) + "/" + res.substring(2);
            post = (res.length < 3 ? "m" : "") + "m/yyyy";
        } else if (res.length < 8) {
            pre = res.substring(0, 2) + "/" + res.substring(2, 4) + "/" + res.substring(4);
            for (let i = 0; i < 8 - res.length; i++)
                post += "y";
        } else {
            pre = res.substring(0, 2) + "/" + res.substring(2, 4) + "/" + res.substring(4);
        }

        setStateData({ pre, post });
        setStateInp(res || "");

        if (onChange)
            onChange(e);

        //update pre/post/inp
    };

    return (

        <div className="ts-date-input">
            <form onSubmit={doOnSubmit}>
                <TSInput id={id} value={stateInp} type="text" onChange={handleInputChanged} className={className} inputMode="numeric" autoComplete="off" />
                <div className="inputOverlay" style={{ direction: "ltr" }}><span className="pre">{stateDate?.pre}</span><span className="marker"></span><span className="post">{stateDate?.post}</span></div>
            </form>
        </div>
    );
};

const TSMonthInput = ({ id, onChange, className }) => {
    const [stateDate, setStateData] = useState({ pre: "", post: "mm/yy" });
    const [stateInp, setStateInp] = useState("");

    const handleInputChanged = (e) => {
        let value = e.target.value || "";
        let clean = value.split("").filter(v => v >= '0' && v <= '9').join("");

        let res = "";
        let step = { stage: "m", val: -1 };
        clean.split("").forEach((v) => {
            switch (step.stage) {
                case "m":
                    if (step.val < 0) {
                        step.val = v * 1;
                        res += v;
                    } else {
                        if (step.val * 10 + v * 1 <= 12 && step.val * 10 + v * 1 >= 1) {
                            step.val = step.val * 10 + v * 1;
                            res += v;
                            step = { stage: "y", val: -1 }
                        }
                        else
                            return false;
                    }
                    break;
                case "y":
                    if (step.val < 0) {
                        if (v * 1 < 4 && v * 1 > 1) {
                            step.val = v * 1;
                            res += v;
                        } else
                            return false;
                    } else {
                        res += v;
                        if (res.length >= 4)
                            step = { stage: "f", val: -1 }
                    }
                    break;
                default:
                    return false;
            }
        });

        if (value && (value.charAt(value.length - 1) === '.' || value.charAt(value.length - 1) === '/')) {
            if (step.stage === 'm' && res.length === 1 && res.substring(0, 1) * 1 > 0)
                res = '0' + res.substring(0, 1);
        }

        res = res.substring(0, 4);

        let pre = "";
        let post = "";
        if (res.length < 2) {
            pre = res;
            post = (res.length < 1 ? "m" : "") + "m/yy";
        } else if (res.length < 4) {
            pre = res.substring(0, 2) + "/" + res.substring(2);
            post = (res.length < 3 ? "y" : "") + "y";
        } else {
            pre = res.substring(0, 2) + "/" + res.substring(2, 4);
        }

        setStateData({ pre, post });
        setStateInp(res || "");

        if (onChange)
            onChange({ target: { value: res } });

        //update pre/post/inp
    };

    return (

        <div className="ts-date-input">
            <TSInput id={id} value={stateInp} type="text" inputMode="numeric" onChange={handleInputChanged} className={className} inputmode="numeric" autoComplete="off" />
            <div className="inputOverlay" style={{ direction: "ltr" }}><span className="pre">{stateDate?.pre}</span><span className="marker"></span><span className="post">{stateDate?.post}</span></div>
        </div>
    );
};

const TSClaimDetails = ({claimData}) => {
    const paymentMethod = {
        "bit": "ביט",
        "bank": "העברה בנקאית"
    }

    const paymentTax = claimData?.paymentTax ?? 0;
    const paymentInterest = claimData?.paymentInterest ?? 0;
    const interestDeductedTax = paymentInterest - paymentTax;

    return (
        <div className="claim-details">
            <div className="details-list">
                <div className="detail">
                    <span>תאריך הגשה:</span>
                    <span>{formatDate(claimData?.submittedAt ?? claimData?.openedAt)}</span>
                </div>
                <div className="detail">
                    <span>סכום החשבוניות:</span>
                    <span>{formatMoney(claimData?.etprice)}</span>
                </div>
                {isInFinishProgressClaim(claimData) && (
                    <>
                <div className="detail">
                    <span>מתוכן <a href="#invoices">קוזז</a>:</span>
                    <span>{(claimData?.etprice - claimData?.eaprice) ? formatMoney(claimData?.etprice - claimData?.eaprice) : ""}</span>
                </div>
                <div className="detail">
                    <span>סכום מאושר:</span>
                    <span>{formatMoney(claimData?.eaprice)}</span>
                </div>
                <div className="detail">
                    <span>השתתפות עצמית:</span>
                    <span>{(claimData?.eaprice - claimData?.expectedPayment) ? formatMoney(claimData?.eaprice - claimData?.expectedPayment) : ""}</span>
                </div>
                <div className="detail">
                    <span>ריבית:</span>
                    <span>{formatMoney(interestDeductedTax > 0 ? interestDeductedTax : "")}</span>
                </div>
                <div className="detail">
                    <span>הצמדה:</span>
                    <span>{formatMoney(sumIfNumbers(claimData?.paymentLinkedIndex))}</span>
                </div>
                <div className="detail">
                    <span>הסכום ששולם:</span>
                    <span>{claimData?.paidTotal != null ? formatMoney(claimData?.paidTotal / 100) : ""}</span>
                </div>
                <div className="detail">
                    <span>תאריך תשלום:</span>
                    <span>{formatDate(claimData?.paidAt)}</span>
                </div>
                <div className="detail">
                    <span>אופן תשלום:</span>
                    <span>{paymentMethod[claimData?.paymentMethod]}</span>
                </div>
                    </>
                    )}
                <div className="detail">
                    <span>מספר תביעה:</span>
                    <span>{claimData?.claimId}</span>
                </div>
                <div className="detail">
                    <span>מספר פוליסה:</span>
                    <span>{claimData?.policyId}</span>
                </div>
            </div>

            <div className="claim-separator"></div>
            <div className="claim-description">
                <span>תאור התביעה:</span>
                <span>{claimData?.eventDescription}</span>
            </div>
        </div>
    )
}

const formatDate = (date) => {
    if (!date) return  "";
    return date.substring(6, 8) + "." + date.substring(4, 6) + "." + date.substring(0, 4);
}

function formatMoney(num) {
    if (isNaN(num) || num == 0) return "";
    return Number(num).toLocaleString("en-US") + " ש\"ח";
}

function sumIfNumbers(a, b) {
    const aNum = parseFloat(a);
    const bNum = parseFloat(b);
    const aValid = !isNaN(aNum);
    const bValid = !isNaN(bNum);

    if (aValid && bValid) return aNum + bNum;
    if (aValid) return aNum;
    if (bValid) return bNum;
    return "";
}

const TSFileCard = ({ file, token }) => {
    return (
        <div className="card white file-container">
            <img src={file.ext === "pdf" ? "/img/tracker/icon-pdf.svg" : "/img/tracker/icon-jpg.svg"} width="20px"/>
            <div className="file-details">
                <span>{file.originalFilename ? file.originalFilename : file.filename}</span>
                <span className="file-size">{sizeFormatter(file.size)}</span>
            </div>
        </div>
    );
}

const sizeFormatter = function (size){
    if (!size || isNaN(size * 1))
        return "";

    size = size * 1;
    if (size > 1024 * 1024)
        return (Math.round(size * 10 / 1024 / 1024) / 10) + " MB";
    else if (size > 1024)
        return (Math.round(size * 10 / 1024) / 10) + " KB";
    else
        return size + "B";
}

const expensesType = {
    vet: "וטרינר",
    lab: "מעבדה",
    hospital: "בית חולים",
    expert: "מומחה",
    physiohydro: "פיזיותרפיה / הידרותרפיה",
    pharma: "תרופות",
    abroad: "חשבונית חו\"ל",
    other: "אחר"
}

const TSExpense = ({ expense, claim }) => {
    return (
        <div className="white card">
            <div className="claim-details">
                <div className="details-list">
                    <div className="detail">
                        <span>חשבונית מספר:</span>
                        <span>{expense?.invoiceNo}</span>
                    </div>
                    <div className="detail">
                        <span>תאריך חשבונית:</span>
                        <span>{formatDate(expense?.invoiceDate)}</span>
                    </div>
                    <div className="detail">
                        <span>גורם המטפל:</span>
                        <span>{expensesType[expense?.type]}</span>
                    </div>
                    <div className="detail">
                        <span>על סך:</span>
                        <span>{formatMoney((expense?.tprice) / 100)}</span>
                    </div>
                    {isInFinishProgressClaim(claim) && (
                    <div className="detail">
                        <span>מתוכם אושרו:</span>
                        <span>{formatMoney((expense?.aprice) / 100)}</span>
                    </div>
                        )}
                </div>
                {expense?.customerComments && isInFinishProgressClaim(claim) && (
                    <>
                <div className="claim-separator"></div>
                <div className="claim-description">
                    <span>הסבר על הקיזוז:</span>
                    <span><pre>{expense?.customerComments}</pre></span>
                </div>
                        </>
                )}
            </div>
        </div>
    );
}

const TSClaimLink = ({ claim, isSelected, onClick }) => {
    let style = {};
    if (!isSelected) {
        style.cursor = "pointer";
    } else {
        style.backgroundColor = "#7fa2f691";
    }

    return (
        <div className="white card linked-claim" onClick={!isSelected ? onClick : undefined} style={style}>
            <span>
                {claim.parentClaimId ? "תביעת המשך" : "תביעה ראשית"}
            </span>
            <span>
                {formatDate(claim?.submittedAt)}
            </span>
        </div>
    )
}

const isInFinishProgressClaim = (claim) => {
    return (claim.status == 15 || claim.status == 20 || claim.status == 21 || claim.status == 37);
}

const isInEarlyProgressClaim = (claim) => {
    return !(claim.status == 0 || claim.status == 1 || claim.status == 2);
}

export { TSPage, TSInput, TSToggle, TSLineSelector, TSAccordion, TSOptionsSelector, TSDateInput, TSMonthInput, TSClaimDetails, TSFileCard, TSExpense, TSClaimLink, isInFinishProgressClaim, isInEarlyProgressClaim }